import GithubSlugger from 'github-slugger';

const headingSlug = heading => {
  const slugger = new GithubSlugger();

  return slugger.slug(heading);
};

export default headingSlug;
